import { render, staticRenderFns } from "./experimentintroduction.vue?vue&type=template&id=041ebb9e&scoped=true&"
import script from "./experimentintroduction.vue?vue&type=script&lang=js&"
export * from "./experimentintroduction.vue?vue&type=script&lang=js&"
import style0 from "./experimentintroduction.vue?vue&type=style&index=0&id=041ebb9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041ebb9e",
  null
  
)

export default component.exports